import React, { Fragment, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminNavbar from "../navbar/adminNavbar";
import classesX from "../Dashboard/dashboard.module.css";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import TrainTicketForm from "./trainTicketForm";
import TrainTicketList from "./trainTicketList";
import TrainTicketUpload from "./trainTicketUpload";
import { emptyTicket } from "./trainTicketConstants";

const TicketGenerator = () => {
  const [active, setActive] = useState("1");
  const [formData, setFormData] = useState(null);
  const [mode, setMode] = useState("manual");

  const tabs = [
    { id: "1", label: "Train Tickets" },
    { id: "2", label: "Create New Ticket" },
  ];

  const openCreate = (data) => {
    setFormData(data || emptyTicket());
    setMode(data ? "manual" : "manual");
    setActive("2");
  };

  const handleExtracted = (data) => {
    setFormData(data);
    setMode("automated");
    setActive("2");
  };

  return (
    <Fragment>
      <AdminNavbar />
      <h1 className={classesX.Heading}>Train Ticket Generator</h1>
      <Container fluid style={{ paddingLeft: 10 }}>
        <Row>
          <Col lg={12} className={classes.Response2}>
            <ul style={{ display: "flex", listStyle: "none", padding: 0, marginBottom: 0 }}>
              {tabs.map((tab) => (
                <li
                  key={tab.id}
                  onClick={() => setActive(tab.id)}
                  style={{
                    flex: 1,
                    textAlign: "center",
                    padding: "12px 0",
                    cursor: "pointer",
                    color: "#fff",
                    backgroundColor: active === tab.id ? "steelblue" : "#585858",
                  }}
                >
                  {tab.label}
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={12} className={classes.Response} style={{ margin: "2vh 1vw", maxWidth: "100%", overflowX: "hidden" }}>
            {active === "1" ? (
              <TrainTicketList onEdit={openCreate} onCreateNew={() => openCreate(null)} />
            ) : (
              <>
                <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
                  <button
                    type="button"
                    className={`btn ${mode === "manual" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => setMode("manual")}
                  >
                    Manual Entry
                  </button>
                  <button
                    type="button"
                    className={`btn ${mode === "automated" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => setMode("automated")}
                  >
                    Upload & Extract (AI)
                  </button>
                </div>
                {mode === "automated" && <TrainTicketUpload onExtracted={handleExtracted} />}
                <TrainTicketForm
                  key={formData ? `form-${formData.pnr || formData.bookingId || "extracted"}` : "form-new"}
                  initialData={formData}
                  onSaved={() => setActive("1")}
                />
              </>
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default TicketGenerator;
